<template>
	<div>
		<pui-modal-dialog-form
			:titleText="$t('modal.vsincronizacionauditoria.verJson.title')"
			:modelName="modelName"
			:dialogName="verJsonModal"
			disable-cancel
			widthDialog="100vw"
			:onShow="onShowVerJsonModal"
		>
			<template slot="message" slot-scope="data">
				<v-layout wrap>
					<v-flex xs12>
						<pui-text-area
							:id="`jsonV${idSufix}`"
							:key="'jsonV_modal_' + keyJson"
							v-model="data.modalData.jsonContent"
							toplabel
							outlined
							solo
							disabled
						></pui-text-area>
					</v-flex>
				</v-layout>
			</template>
		</pui-modal-dialog-form>
		<pui-modal-dialog-form
			:titleText="$t('modal.vsincronizacionauditoria.republicar.title')"
			:modelName="modelName"
			:dialogName="republicarModal"
			:onOk="onOkRepublicarModal"
			:onShow="onShowRepublicarModal"
		>
			<template slot="message">
				<v-row dense>
					<v-col cols="12">
						<label style="font-weight: bold;color:#166bf2">{{
							$t('modal.vsincronizacionauditoria.republicar.confirm')
						}}</label>
					</v-col>
				</v-row>
			</template>
		</pui-modal-dialog-form>
	</div>
</template>

<script>
export default {
	name: 'vsincronizacionauditoria-modals',
	data() {
		return {
			verJsonModal: 'vsincronizacionauditoriaVerJsonAction',
			republicarModal: 'vsincronizacionauditoriaRepublicarAction',
			idSufix: `-${this.modelName}-modal`,
			keyJson: 0
		};
	},
	props: {
		modelName: {
			required: true,
			type: String
		}
	},
	methods: {
		onShowVerJsonModal(modalData) {
			modalData.jsonContent = this.$puiI18n.t('modal.vsincronizacionauditoria.verJson.loading');
			const url = this.$store.getters.getModelByName(this.modelName).url.getJson;
			const title =
				this.$puiI18n.t('puiaction.notifyTitle') +
				' > ' +
				this.$puiI18n.t('modal.vsincronizacionauditoria.verJson.title');
			return new Promise((resolve) => {
				this.$puiRequests.getRequest(
					url,
					modalData.headerPk,
					(response) => {
						const payload = response.data;
						modalData.jsonContent = typeof payload === 'string'
							? payload
							: JSON.stringify(payload, null, 2);
						this.keyJson++;
						resolve(true);
					},
					(e) => {
						let message = this.$puiI18n.t('puiaction.notifyError');
						if (e.response && e.response.data) {
							message = e.response.data.message;
						}
						this.$puiNotify.error(message, title);
						resolve(false);
					}
				);
			});
		},
		onShowRepublicarModal(modalData) {
			console.log(modalData);
		},
		onOkRepublicarModal(modalData) {
			const url = this.$store.getters.getModelByName(this.modelName).url.republicar;
			const title =
				this.$puiI18n.t('puiaction.notifyTitle') +
				' > ' +
				this.$puiI18n.t('modal.vsincronizacionauditoria.republicar.title');
			const body = {
				dueportauditid: modalData.dueportauditid,
				status: modalData.status
			};
			return new Promise((resolve) => {
				this.$puiRequests.patchRequest(
					url,
					body,
					() => {
						this.$puiNotify.success(this.$puiI18n.t('puiaction.notifySuccess'), title);
						this.$puiEvents.$emit('onPui-action-running-ended-' + this.modelName);
						resolve(true);
					},
					(e) => {
						let message = this.$puiI18n.t('puiaction.notifyError');
						if (e.response && e.response.data) {
							message = e.response.data.message;
						}
						this.$puiEvents.$emit('onPui-action-running-ended-' + this.modelName);
						this.$puiNotify.error(message, title);
						resolve(false);
					}
				);
			});
		}
	}
};
</script>
